/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PaymentMethodCode } from './paymentMethodCode.model';


export interface SubjectContactPaymentDataDto { 
    account?: string;
    bankCode?: string;
    bankName?: string;
    contactId?: number;
    iban?: string;
    id?: number;
    paymentMethod?: PaymentMethodCode;
    specSym?: string;
    subjectId?: number;
    swift?: string;
    usedOnAnyContract?: boolean;
    varSym?: string;
    withdrawPostage?: boolean;
}
export namespace SubjectContactPaymentDataDto {
}


